import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router';
import type { FunctionComponent } from 'react';

import { encodeReference } from '../../../shared/utils/encodeReference';
import { useParams } from '../../contexts/RouterContext';
import { useCurrentProject } from '../../hooks/api/projects/useCurrentProject';
import NavigationStore from '../../redux/navigation';
import utils from '../../utils';
import Redirect from '../generic/Redirect';

import type { RevisionRouteParams } from './projectDashboardTypes';

const ProjectEmpty: FunctionComponent = () => {
  const dispatch = useDispatch();
  const params = useParams<RevisionRouteParams>();
  const { data: project } = useCurrentProject();

  useEffect(() => {
    if (!project || !project.default_branch || !project.locator) {
      dispatch(NavigationStore.actions.setNavState({
        expand: null,
        subnav: null,
        navProps: {},
      }));
    }
  }, [dispatch, project]);

  if (
    !params.reference &&
    project?.default_branch &&
    project?.locator
  ) {
    return (
      <Redirect
        replace
        to={`/projects/${utils.nuc(project.locator)}/refs/branch/${encodeReference(project.default_branch)}`}
      />
    );
  }

  return (
    <div className="text-center">
      <h1>404 - Project not found</h1>
      <hr />
      <Link to="/">
        <Button bsStyle="primary">Go Back Home</Button>
      </Link>
    </div>
  );
};

export default ProjectEmpty;
